import { observer } from 'mobx-react';
import { FunctionComponent, useContext, useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';
import { Production } from '../../config/Config';
import { AppContext } from '../../contexts/AppContext';
import { BillingStatus } from '../../data/models/Group';

export const Intercom: FunctionComponent = observer(() => {
  const { GroupStore, UserStore } = useContext(AppContext);
  const { update } = useIntercom();

  useEffect(() => {
    (async () => {
      if (UserStore.isAuthenticated && UserStore.user != null && GroupStore.initialLoadCompleted) {
        const groups = await Promise.all(
          UserStore.user.groups
            .filter(group => GroupStore.groups.has(group.groupId))
            .filter(group => GroupStore.groups.get(group.groupId).hasNameSet)
            .map(async userGroup => {
              const group = GroupStore.groups.get(userGroup.groupId);
              let plan = 'trial';
              let nextBillingDate: number | string = '';
              const products = [
                group.hasRecharger ? 'Recharger' : null,
                group.hasBrag ? 'BRAG' : null,
                group.hasBalancer ? 'Balancer' : null,
              ].filter(v => v != null).join(', ');

              if (group.billingStatus === BillingStatus.ACTIVE) {
                await group.loadSubscription();

                if (group.subscription) {
                  plan = group.subscription.plan;
                  nextBillingDate = group.subscription.nextBillDate.toSeconds();
                }
              }

              return {
                companyId: `${Production ? 'prd' : 'dev'}-${userGroup.groupId}`,
                name: group.name,
                plan,
                customAttributes: {
                  trial_end: group.billingStatus === BillingStatus.TRIAL ? group.trialEnd.toSeconds() : '',
                  next_bill_date: nextBillingDate,
                  billing_frequency: group.subscription ? group.subscription.billingFrequency : '',
                  num_entities: group.apiOrganisations.length,
                  products,
                },
              };
            })
        );

        update({
          name: `${UserStore.user.forename} ${UserStore.user.surname}`,
          email: UserStore.user.email,
          userHash: UserStore.user.hash,
          companies: groups,
        });
      }
    })();
  }, [UserStore.user, GroupStore.groups.size]);

  return null;
});
